var style = document.createElement("style");
style.setAttribute("less", "responsive-frame.less");
style.innerHTML = "responsive-frame {\n  display: block;\n}\nresponsive-frame a {\n  display: none;\n}\n";
document.head.insertBefore(style, document.head.firstElementChild);
